<template>
  
   
  <div class="steps-gradient">
     
    <div id="steps-gradient-scroller">
      <div id="scrollToContainer">
        <ul class="steps-wrap collapsible steps">
          <!--@click="function(evt){stepClickHandler(i, evt)}" -->
          <li
            :key="i"
            v-for="(step, i) in steps"
            @click="function(evt){stepClickHandler(i, evt)}"
            class="z-depth-2"
            :id="'step_' + i"
            :class="{step: true, editing: editing, active: i == current_step, nonActive: i != current_step, toResync: i > current_step, hideStepActions: uploading || resyncing || stepActionsDisabled}"
            :style="{borderColor: inTemplate ? colors[i%colors.length] : '#27AAE1'}"
          >
            <div class="stepNum">{{displayStepNumber(i)}}</div>

            <div v-if="resyncing || !editing ||  i != current_step" class="collapsible-header">
              <div
                v-if="resyncing || !editing ||  i != current_step"
                class="step-title"
              >{{step.title || 'Step Title'}}</div>
            </div>
            <div class="collapsible-body">
              <div v-if="!resyncing && editing &&  i == current_step" class="input-field s12 title">
                <input
                  v-model="step.title"
                  id="stepFormTitle"
                  type="text"
                  class="step-title-input"
                  
                  :maxlength="100"
                />
                <label for="stepFormTitle">Step title</label>
                <span class="right helper-text">{{step.title.length}} / 100</span>
              </div>
              <div class="step-description" v-if="!editing " v-html="step.description"></div>
              <div v-if="editing " class="input-field step-description-input">
                <textarea v-once
                  v-bind:id="'textedit_'+step.i"
                  class="editable materialize-textarea"
                  data-length="120"
                  v-model="step.description"
                  placeholder=" "
                ></textarea>
                <label
                  v-bind:for="'textedit_'+step.id"
                  class="step-description-label"
                >Step description</label>
              </div>

              <div
                class="step-actions"
                v-if="!videoError && !editing && inTemplate && !resyncing && !updatingStep && !processing"
              >
                <a
                  class="btn btn-flat modal-trigger waves-effect waves-light"
                  :href="'#deleteModal'+i"
                  v-if="i > 0"
                >Delete</a>
                <div :id="'deleteModal'+i" class="deleteModal modal">
                  <div class="modal-content">
                    <h4>Delete Step?</h4>
                    <p v-if="video_url">
                      After the step is deleted, you'll immediately be guided through resyncing each step in the tutorial.
                      <br />Other step content won't be affected.
                    </p>
                    <p v-if="!video_url">
                      Are you sure you want to delete this step?
                    </p>
                  </div>
                  <div class="modal-footer">
                    <a class="modal-close btn btn-flat waves-effect waves-light">Cancel</a>

                    <a
                      class="modal-close btn btn-flat waves-effect waves-light"
                      @click="deleteStep(i)"
                    >Delete</a>
                  </div>
                </div>
                <a class="btn btn-flat waves-effect waves-light" @click="edit_click(i)">Edit</a>
              </div>
              <div
                class="step-actions"
                v-if="editing && !syncing && !updatingStep && !resyncing && i < steps.length-1"
              >
              
                <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="cancelEdit(i)"
                  :class="{disabled: updatingStep}"
                >CANCEL</a>
                <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="updateStep()"
                  :class="{disabled: updatingStep || !canSaveCurrentStep}"
                >UPDATE STEP</a>
              </div>
              <div
                class="step-actions"
                v-if="!videoError && editing && i == current_step && i == steps.length -1  && video_url "
              >
              
              <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="cancelEdit(i)"
                  :class="{disabled: updatingStep}"
                  v-if="(i == 0 && !didUploadVideo) || i > 0"
                >CANCEL</a>
                
                <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="syncVideoClick()"
                  :class="{disabled: syncing || step.title.length ==0 || step.description.length==0 || step.title== PLACEHOLDER_TITLE || step.description == PLACEHOLDER_DESC }"
                >SYNC TO VIDEO</a>
                <!--
                <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="syncVideoClick()"
                  :class="{disabled: syncing || step.title.length ==0 || step.description.length==0 || step.title== PLACEHOLDER_TITLE || step.description == PLACEHOLDER_DESC }"
                >{{step.new || (step.end_time < videoDuration)?"SYNC TO VIDEO":"CUPDATE STEP"}}  </a>
                -->
              </div>

              <div
                class="step-actions"
                v-if="editing && !video_url && !resyncing && i == current_step && !updatingStep && steps.length > 1  && i == steps.length -1 "
              >
                
                <a
                  class="btn btn-flat waves-effect waves-light"
                  @click="updateStep()"
                  :class="{disabled: updatingStep || !canSaveCurrentStep}"
                >FINAL STEP</a>
              </div>

              <div class="step-actions" v-if="updatingStep && i == current_step">
                <div class="preloader-wrapper small active">
                  <div class="spinner-layer spinner-blue-only">
                    <div class="circle-clipper left">
                      <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                      <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                      <div class="circle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  
</template>
<script>
import { HelmetProvider, Helmet } from "@jnields/vue-helmet";
export default {
  props: [
    "didUploadVideo",
    "steps",
    "current_step",
    "step_click",
    "editStep",
    "edit_click",
    "delete_click",
    "syncVideoClick",
    "syncing",
    "resyncing",
    "deleteStep",
    "editing",
    "toggleEditing",
    "cancelEdit",
    "updateStep",
    "updatingStep",
    "inTemplate",
    "canSaveCurrentStep",
    "video_url",
    "showAddAnother",
    "addAnother",
    "uploading",
    "videoError",
    "processing",
    "stepActionsDisabled",
    "videoDuration"
  ],

  data() {
    return {
      mInstance: false,
      editor: false,
      colors: ["#25aae1", "#8cc63f", "#f172a6", "#13a89e", "#fcb040", "#8cc63f"],
      PLACEHOLDER_TITLE: "Hello, world.",
      PLACEHOLDER_DESC: '<p>Have an intro? Make the title of this step "Intro" or "Introduction" to not assign a step # here. </p><p> Highlight text or use keyboard shortcuts to bold, italicize, underline, link, and/or create ordered/unordered lists.</p>',

    };
  },
  computed: {
    indexAtZero: function() {
      if (this.steps && this.steps[0] && this.steps[0].title) {
        return this.steps[0].title.toLowerCase().includes("intro");
      } else {
        return false;
      }
    }
  },

  mounted() {
    this.setUpEditor();

    $(document).ready(function() {
      $(".modal").modal();
    });
  },

  methods: {
    stepClickHandler(i, evt) {
      if (i == this.current_step && !$(evt.target).is("a")) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      } else if ($(evt.target).is("a")) {
        return
      } else {
        if(this.inTemplate){
          evt.stopPropagation();
          evt.preventDefault();
          this.step_click(i);
        }else if (this.inTemplate==undefined){
          this.step_click(i)
          var elem = $('.steps.collapsible')[0]
          var instance = M.Collapsible.getInstance(elem);
          instance.close(this.current_step)
         // this.current_step=i
          setTimeout(function () {
            //self.scrollToStep(i);  
            instance.open(i)
          }, 300)
          
        }

        if (i + 1 != this.steps.length) {
          //console.log("Setting editing to false")
         // this.editing = false;
        }
        //this.step_click(i);
        //this.setUpEditor();
      }
    },

    setUpEditor() {
      M.AutoInit();
      var self = this;
      if (this.editor) {
        this.editor.destroy();
      }
      this.editor = new MediumEditor(".editable", {
        placeholder: false,
        buttonLabels: "fontawesome",
        autoLink: true,
        targetBlank: true,
        placeholder: {
          text: "Step Description",
          hideOnClick: true
        },
        toolbar: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "anchor",
            "orderedlist",
            "unorderedlist",
            "pre"
          ]
        }
      });
    },

    headerClick(evt) {
      var self = this;
      if (this.editing) {
        setTimeout(function() {
          self.setUpEditor();
        }, 300);
      }
    },

    displayStepNumber(i) {
      if (this.indexAtZero) {
        if (i == 0) {
          return "";
        } else {
          return i;
        }
      } else {
        return i + 1;
      }
    }
  }
};
</script>

<style scoped>
textarea::placeholder {
  color: red;
}
.resyncing .step-collapsible-content {
  display: none;
}
.steps-gradient {
  /* margin-top: -10px; */
  /* padding-top: 10px; */
}

.steps-wrap {
  padding: 10px;
  padding-left: 0;
  margin-top: -8px;
}
.steps-wrap.collapsible {
  border: none;
  box-shadow: none;
}
.deleteModal {
  text-align: left;
}
pre {
  white-space: pre-wrap;
}
.nonActive {
  cursor: pointer;
}
.nonActive .collapsible-body {
  display: none !important;
}
.nonActive .input-field {
  margin: 0;
  height: 0;
  padding: 0;
}
.active .step-title {
  /* border-bottom: 1px solid #b7b9bb; */
}
.step-actions {
  font-weight: 500;
}
.editing .step-actions {
  padding: 0px;
}
.nonActive.step {
  border-color: #58595b !important;
}
.nonActive .step-number {
  background-color: #58595b !important;
}
.resyncing .nonActive.step.toResync {
  border-color: #f1f1f1 !important;
}
.resyncing .nonActive.toResync .step-number {
  background-color: #f1f1f1 !important;
}
.nonActive .step-collapsible-content {
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  transition: padding 0s ease !important;
}
.hideInteractivity .step-collapsible-content {
  max-height: 0 !important;
}
.hideInteractivity .step {
  pointer-events: none !important;
}
.step-collapsible-content {
  overflow: hidden;
  width: 100%;
}
.medium-editor-element {
  outline: none !important;
}

.step,
.step-content,
.step-collapsible-content,
.step-number {
  transition: all 0.5s ease-in-out;
  transition: padding 0s ease !important;

  height: auto;
  max-height: 1500px;
  max-width: 100%;
}
.resyncing .step {
  cursor: unset;
  pointer-events: none;
}
.step {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  /* align-content: center; */

  flex-wrap: wrap;
  border-left: 50px solid #27aae1;
  margin-bottom: 24px;
  line-height: 20px;
}
.stepNum {
  margin-left: -50px;
  width: 50px;
  height: 100%;
  line-height: 50px;
}
.input-field.title {
  padding-bottom: 24px;
}
.step .collapsible-header,
.step .collapsible-body {
  flex-grow: 1;
  flex-shrink: 0;
  padding: 12px;
  text-align: left;
  max-width: 99%;
}
.step .collapsible-body {
  width: 100%;
}
.stepNum {
  width: 50px;
  min-width: 50px;
  min-height: 100%;
  color: #ffffff;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  /* background-color: #27aae1; */
  height: 100%;
  text-align: center;
  margin-left: -50px;
}
.editing.step.active .step-content {
  /* padding: 12px; */
}
.step-content {
  text-align: left;

  flex: 1;
}
.step-title,
.step-description {
  /* padding: 12px; */
}
.step-description {
  padding-top: 0;
  padding-bottom: 0;
}
.step-actions {
  text-align: right;
}
.step-actions .btn-flat {
  color: #27aae1;
}
.step-actions .btn-flat:hover {
  color: white;
  background-color: rgba(35, 168, 225, 0.4);
}
.step-title {
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}

.editing .collapsible-header {
  border: none;
  outline: none;
}
.collapsible-header:focus {
  outline: none;
}
li:before {
  content: 1;
  width: 50px;
  color: white;
  background-color: #27aae1;
  height: 100%;
}

.steps-gradient {
  position: relative;
  /* max-width: 425px; */
}

.steps-gradient::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25px;
  background: linear-gradient(rgba(255, 255, 255, 0.001), white);
  pointer-events: none;
}
.in-template #steps-gradient-scroller {
  margin-top: 21px;
}
#steps-gradient-scroller {
  overflow-y: scroll;
  background: white;
  width: 100%;
  height: 375px;
  padding: 0px 0;
  line-height: 1.2;
  text-align: center;
  scrollbar-width: none!important;
  /* padding-top: 22px; */
  /* margin-top: 22px; */
}
#steps-gradient-scroller::-webkit-scrollbar {
  display: none;
}
.steps-wrap {
  margin-left: 30px;
}
.editable {
  border-bottom: 1px solid #9e9e9e;
  transition: all 2s ease-out;
  transition: box-shadow 0.3s, border 0.3s, -webkit-box-shadow 0.3s;
  padding-top: 8px;
  /* transform .2s ease-out, color .2s ease-out, -webkit-transform .2s ease-out */
}
.editable:focus {
  border-bottom: 1px solid #26a69a;
  -webkit-box-shadow: 0 1px 0 0 #26a69a;
  box-shadow: 0 1px 0 0 #26a69a;
}
@media only screen and (max-width: 601px) {
  .step-title {
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
  }
  .step-description {
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 12px;
    line-height: 16px;
  }
  .steps-wrap {
    margin-left: 12px;
    margin-right: 12px;
    padding-right: 0;
  }
}
.add-another-step-row {
  text-align: right;
  margin-top: 0px;
}
</style>
<style>

.step-description ul:not(.browser-default) > li {
  list-style-type: disc !important;
}

.step-description ul:not(.browser-default) {
  padding-left:20px !important;
  list-style-type: disc !important;
}

.step-description .step ul {
  list-style-type: disc !important;
  padding-left: 20px !important;
  line-height: 20px !important;
}

.editable ul:not(.browser-default) > li {
  list-style-type: disc !important;
}

.editable ul:not(.browser-default) {
  padding-left:20px !important;
  list-style-type: disc !important;
}

.editable .step ul {
  list-style-type: disc !important;
  padding-left: 20px !important;
  line-height: 20px !important;
}

.hideStepActions .step-actions {
  display: none !important;
}
.hideStepActions {
  pointer-events: none;
  cursor: normal;
}
.nonActive .collapsible-header {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Steps.vue